export const NO_ACCESS_NAVBAR_TEST_ID = "no-access-navbar";
